import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getBudgetByIdSelector } from '_modules/budget/selectors'

const useBudgetPdfFileName = ({ budgetId }) => {
  const budget = useSelector(getBudgetByIdSelector(budgetId))

  const pdfFileName = useMemo(() => {
    const dateTimeNow = new Date().toLocaleString()
    return `orcamento_${budget?.serviceOrder}_${budget?.id}_${dateTimeNow}.pdf`
  }, [budget?.id, budget?.serviceOrder])

  return pdfFileName
}

export default useBudgetPdfFileName
